import React from 'react';
import { Chip, Grid, makeStyles, Tooltip, Typography } from '@material-ui/core';
import SvgCircle from './svgCircle';

const useStyles = makeStyles(() => ({
  row: {
    height: 'auto',
    background: '#fff',
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    marginTop: 16,
    padding: 24,
  },
  resumeName: {
    fontFamily: 'Roboto',
    fontSize: 18,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 16,
  },
  scoreBox: {
    borderRadius: 2,
    backgroundColor: '#f3f3f3',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    fontStyle: 'normal',
    letterSpacing: 0.2,
    textAlign: 'left',
    color: '#49515a',
    padding: '10px',
    display: 'flex',
    justifyContent: 'space-between',

    '& span': {
      '&:last-child': {
        color: '#4b8c6f',
      },
    },
  },
  missingSkillsTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0.46,
    textAlign: 'left',
    color: 'rgba(0, 0, 0, 0.6)',
    margin: '16px 0 8px',
  },
  chip: {
    marginRight: 7,
  },
}));

const ExplainableMatchCard = ({ talent }) => {
  const { missing_skills, scores, resume } = talent;
  const classes = useStyles();

  return (
    <Grid container className={classes.row}>
      <Grid item xs={9}>
        <Typography classes={{ root: classes.resumeName }}>
          <b>{resume}</b>
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Typography classes={{ root: classes.scoreBox }}>
              <span>Skill Score:</span>
              <span>{scores.skills.score * 100}</span>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography classes={{ root: classes.scoreBox }}>
              <span>Job Title Score:</span>
              <span>{scores.job_title.score * 100}</span>
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography classes={{ root: classes.scoreBox }}>
              <span>Experience Score:</span>
              <span>{scores.experience.score * 100}</span>
            </Typography>
          </Grid>
        </Grid>
        <Typography classes={{ root: classes.missingSkillsTitle }}>
          Missing Skills:
        </Typography>
        {missing_skills.slice(0, 3).map((skill) => (
          <Chip
            classes={{ root: classes.chip }}
            title={skill}
            key={skill}
            label={skill}
            color="primary"
            // variant="contained"
          />
        ))}
        {missing_skills.length > 3 ? (
          <Tooltip title={missing_skills.slice(3).join(', ')}>
            <Chip
              classes={{ root: classes.chip }}
              label={<>{`+ ${missing_skills.length - 3}`}</>}
              color="default"
              variant="outlined"
            />
          </Tooltip>
        ) : null}
      </Grid>
      <Grid item xs={3} style={{ textAlign: 'right' }}>
        <SvgCircle match={scores.overall_score.score * 100} />
      </Grid>
    </Grid>
  );
};

export default ExplainableMatchCard;
